export default __webpack_public_path__ + "static/furnatura-prague-45ead1690d3412e42ed7b146949a1dbc.svg";